import { EpssScore } from "~/operations";
import { ordinalize } from "./ordinalize";

export function formatEpssScore({
  probability,
  percentile,
}: Pick<EpssScore, "probability" | "percentile">) {
  return `${formatEpssProbability(probability)} (${formatEpssPercentile(percentile)})`;
}

export function formatEpssProbability(probability: number) {
  const percent = probability * 100;
  const value = percent > 0 ? clampFloat(percent, 2) : "0";
  const suffix = "%";
  return value + suffix;
}

export function formatEpssPercentile(percentile: number) {
  const percent = percentile * 100;
  const value = clampFloat(percent, 0, "floor");
  const digits = parseInt(value.replace("<", "").split(".").pop() || "0");
  const suffix = ordinalize(digits).slice(-2);
  return value + suffix;
}

function clampFloat(
  float: number,
  precision: number,
  roundingMode?: Intl.NumberFormatOptions["roundingMode"],
) {
  const toFixed = new Intl.NumberFormat("en", {
    maximumFractionDigits: precision,
    roundingMode,
  }).format;
  const floor = 1 / Math.pow(10, precision);
  return float < floor ? "<" + toFixed(floor) : toFixed(float);
}
